import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bt-icon bt-icon--sm" }
const _hoisted_2 = { class: "dialog-custom__footer" }
const _hoisted_3 = {
  key: 0,
  class: "app-loader app-loader--contextual"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_DialogPlantCreateStep3 = _resolveComponent("DialogPlantCreateStep3")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDialogVisible = $event)),
    showHeader: false,
    modal: true,
    onHide: _ctx.doHideDialog,
    class: "dialog-custom dialog-structure-create"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "close",
        onClick: _ctx.handleHideDialog,
        class: "dialog-custom__close-button p-button-text"
      }, {
        default: _withCtx(() => [
          _createVNode("span", _hoisted_1, [
            _createVNode(_component_InlineSvgScoped, {
              src: require(`@/assets/images/icons/icon-close.svg`)
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_DialogPlantCreateStep3, {
        plant: _ctx.plant,
        onIsLoading: _ctx.handleLoading,
        "is-in-edit-mode": _ctx.isEditMode
      }, null, 8, ["plant", "onIsLoading", "is-in-edit-mode"]),
      _createVNode("footer", _hoisted_2, [
        _createVNode(_component_Button, {
          onClick: _ctx.handleButtonSubmitAction,
          label: _ctx.$t('AppResource.SaveAndExit'),
          class: "p-button-rounded p-button-raised p-button--m"
        }, null, 8, ["onClick", "label"])
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_ProgressSpinner)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}